import type { UserDashboardApiGeneralSettings } from '#/modules/userDashboard/api/types/UserDashboardApiGeneralSettings';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  generalSettings: UserDashboardApiGeneralSettings;
};

function mapResponse(data: ApiResponse) {
  return data.generalSettings;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/userdashboard/general-settings',
  mapResponse,
});

// Exports

export const userDashboardApiFetchGeneralSettings =
  endpoint.createClientFetchFn();

export const userDashboardApiIsomorphicFetchGeneralSettings =
  endpoint.createIsomorphicFetchFn();

export const useUserDashboardApiFetchGeneralSettings =
  endpoint.createUseFetchHook();
